<template>
  <v-dialog v-model="dialog" persistent max-width="550px">
    <v-card>
      <!--TITLE-->
      <v-card-title class="red-darken-3">
        <span class="headline">{{
          $t("repositories.form.edit_locations")
        }}</span>
      </v-card-title>
      <!--BODY-->
      <v-card-text>
        <v-row class="justify-center">
          <!--ALERT-->
          <v-col cols="12" xs="12" md="12" lg="12">
            <v-alert
              :model-value="alert.value"
              :type="alert.type"
              variant="tonal"
              border="bottom"
            >
              {{ alert.message }}
            </v-alert>
          </v-col>
          <!--X-->
          <v-col cols="6" xs="4" md="4" lg="4">
            <v-text-field
              v-model="x"
              class="mr-2"
              label="X"
              color="red-darken-1"
              type="number"
              :min="initial.x"
              oninput="validity.valid || (value = '')"
            />
          </v-col>
          <!--Y-->
          <v-col cols="6" xs="4" md="4" lg="4">
            <v-text-field
              v-model="y"
              class="ml-2 mr-2"
              label="Y"
              color="red-darken-1"
              type="number"
              :min="initial.y"
              oninput="validity.valid || (value = '')"
            />
          </v-col>
          <!--CODE-->
          <v-col cols="6" xs="4" md="4" lg="4">
            <v-text-field
              v-model="code"
              class="ml-2"
              :label="$t('repositories.form.code')"
              color="red-darken-1"
            />
          </v-col>
          <!--NOTES-->
          <v-col cols="12" xs="12" md="12" lg="12">
            <v-text-field
              v-model="notes"
              :label="$t('repositories.form.notes')"
              color="red-darken-1"
            />
          </v-col>

          <!--WARNING LABEL-->
          <v-col cols="12" xs="12" md="12" lg="12">
            <v-row class="mt-2">
              <v-alert
                type="error"
                class="mt-4"
                variant="tonal"
                border="bottom"
              >
                {{ $t("repositories.form.location_changes") }}
              </v-alert>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!--ACTION BUTTONS-->
      <v-card-actions>
        <v-spacer />
        <!--CLOSE-->
        <v-btn color="red-darken-1" variant="outlined" @click="close">
          {{ $t("repositories.form.close") }}
        </v-btn>
        <!--SAVE-->
        <v-btn
          :loading="loading"
          :disabled="disabled || !x || !y"
          color="blue darken-1"
          variant="outlined"
          @click="save"
        >
          {{ $t("repositories.form.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import putRequest from "../../api/putRequest";

export default {
  data: () => ({
    alert: { value: false, message: null, type: "error" },
    dialog: false,
    loading: false,
    disabled: false,
    repositoryId: null,
    roomId: null,
    locationId: null,
    x: null,
    y: null,
    initial: {
      // The initial values of the fields.
      x: null,
      y: null,
    },
    code: null,
    notes: null,
  }),
  methods: {
    open(data) {
      this.x = data.location.position_x;
      this.y = data.location.position_y;
      this.initial = {
        x: data.location.position_x,
        y: data.location.position_y,
      };
      this.code = data.location.code;
      this.notes = data.location.notes;
      this.repositoryId = data.repository._id;
      this.roomId = data.room._id;
      this.locationId = data.location._id;
      this.dialog = true;
    },
    clear() {
      this.x = null;
      this.y = null;
      this.initial = { x: null, y: null };
      this.repositoryId = null;
      this.roomId = null;
      this.locationId = null;
      this.dialog = false;
      this.disabled = false;
      this.alert = { value: false, message: null, type: "error" };
    },
    close() {
      this.clear();
      this.$emit("close", { saved: false });
    },
    save() {
      this.loading = true;
      putRequest("/repository/location", "", {
        repositoryId: this.repositoryId,
        roomId: this.roomId,
        locationId: this.locationId,
        x: this.x,
        y: this.y,
        code: this.code,
        notes: this.notes,
      })
        .then((response) => {
          this.loading = false;
          this.$emit("save", {
            saved: true,
            editedRepository: response.data,
          });
          this.clear();
        })
        .catch((error) => {
          this.loading = false;
          this.alert = { value: true, message: error.message, type: "error" };
          this.disabled = true;
          setTimeout(() => {
            this.alert.value = false;
            this.disabled = false;
          }, 2000);
        });
    },
  },
};
</script>
